import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
const {
  BASE_FONT_FAMILY,
  LOGIN_TEXT_COLOR,
  LOGIN_FORM_BG_COLOR,
  LOGIN_HIGHLIGHT_COLOR,
  LOGIN_INPUT_COLOR,
  DANGER_STATUS_COLOR
} = constants;

let styles = {
  base: {
    fontSize: '1.1em',
    color: LOGIN_TEXT_COLOR,
    fontFamily: BASE_FONT_FAMILY,
    height: 47,
    width: '100%',
    border: `1px solid ${LOGIN_HIGHLIGHT_COLOR}`,
    borderRadius: 5,
    backgroundColor: LOGIN_FORM_BG_COLOR,
    margin: 10,
    padding: '10px 27px',
    boxSizing: 'border-box',
    '::placeholder': {
      color: LOGIN_INPUT_COLOR
    }
  },
  error: {
    fontSize: '0.9em',
    fontWeight: 500,
    paddingTop: 3,
    paddingLeft: 1,
    color: DANGER_STATUS_COLOR
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/inputs/logininput/LoginInput.styles.js